import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useApi } from '@/api/ApiContext';
import type { SupplierPaymentsQuery } from '@/api/handlers/resources/suppliers/requests';
import type { GetSupplierPaymentsResponse } from '@/api/handlers/resources/suppliers/responses';
import type { ApiResponse } from '@/api/handlers/responses';
import { SupplierQueryKeys } from './supplierQueryKeys';

/**
 * Reads `GET /suppliers/{id}/payments` (BOS-120) — one page of the supplier's
 * payments, newest first. Disabled until a supplier is selected, so the detail
 * drawer can mount before one is.
 */
export const useSupplierPaymentsQuery = (
    supplierId: string | null,
    query: SupplierPaymentsQuery,
    enabled = true,
) => {
    const { apiClient } = useApi();

    return useQuery<ApiResponse<GetSupplierPaymentsResponse>>({
        queryKey: SupplierQueryKeys.paymentsPage(supplierId ?? '', query),
        queryFn: () =>
            apiClient.suppliers.getSupplierPayments(supplierId ?? '', query),
        enabled: enabled && supplierId !== null,
        staleTime: 60_000,
        placeholderData: keepPreviousData,
    });
};
